import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import e from "clsx";
import { WarningIcon as p } from "../../icons/WarningIcon.js";
import { Typography as f } from "../Typography/Typography.js";
import '../../_assets/RadioButton.DZHRUSI_.css';const u = "_field_hl9o5_44", k = "_label_hl9o5_50", E = "_input_hl9o5_57", N = "_checkmark_hl9o5_65", g = "_icon_hl9o5_74", b = "_name_hl9o5_94", x = "_error_hl9o5_135", y = "_iconError_hl9o5_143", v = "_messageError_hl9o5_150", o = {
  field: u,
  label: k,
  input: E,
  checkmark: N,
  icon: g,
  name: b,
  error: x,
  iconError: y,
  messageError: v,
  "slide-in-out": "_slide-in-out_hl9o5_1",
  "fade-in-out": "_fade-in-out_hl9o5_1"
}, R = d(
  ({ className: n, id: l, label: s, disabled: i, name: t, value: _, error: c, ...m }, h) => /* @__PURE__ */ a("div", { className: e(o.field, n), children: [
    /* @__PURE__ */ r(
      "input",
      {
        ref: h,
        id: l,
        type: "radio",
        value: _,
        disabled: i,
        className: o.input,
        name: t,
        ...m
      }
    ),
    /* @__PURE__ */ a("label", { htmlFor: l, className: e(o.label), children: [
      /* @__PURE__ */ r("span", { className: o.checkmark, children: /* @__PURE__ */ r("span", { className: e(o.icon, n), children: " " }) }),
      s && /* @__PURE__ */ r(
        f,
        {
          variant: "portalText",
          size: "2",
          color: "black-new",
          className: e(o.name, n),
          children: s
        }
      )
    ] }),
    c && /* @__PURE__ */ a("div", { className: o.error, role: "alert", children: [
      /* @__PURE__ */ r("span", { className: o.iconError, children: /* @__PURE__ */ r(p, {}) }),
      /* @__PURE__ */ r("span", { className: o.messageError, children: c })
    ] })
  ] })
);
R.displayName = "RadioButton";
export {
  R as RadioButton
};
